"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _capitalize = _interopRequireDefault(require("lodash/capitalize"));
var _first = _interopRequireDefault(require("lodash/first"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _utils = require("../../../../utils");
var _chevronDown = _interopRequireDefault(require("../../../../assets/svg/chevron-down.svg"));
var _icons = require("../../../icons");
var _contactTags = _interopRequireDefault(require("../../../contact-tags"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var GeneralInfo = function GeneralInfo(_ref) {
  var student = _ref.student,
    goToMyResume = _ref.goToMyResume,
    onSeeking = _ref.onSeeking,
    disabledResume = _ref.disabledResume,
    showPrivate = _ref.showPrivate,
    viewDiversities = _ref.viewDiversities,
    showPhone = _ref.showPhone,
    applicant = _ref.applicant,
    contactTags = _ref.contactTags,
    isSavingContactTags = _ref.isSavingContactTags,
    showContactTagsSelector = _ref.showContactTagsSelector,
    onContactTag = _ref.onContactTag,
    showContactTags = _ref.showContactTags,
    onSetShowContactTags = _ref.onSetShowContactTags;
  var subtitle = (0, _utils.getGeneralSubtitle)(student);
  var title = (0, _utils.getGeneralTitle)(student);
  // const majorName = getMajorName(student);
  var diversities = student.diversity.filter(function (diversity) {
    return diversity.added === 1;
  });
  var seeking = Boolean(parseInt(student.seeking, 10));
  var studentCityOfHomeName = student.cityOfHomeName ? "".concat(student.cityOfHomeName, ", ") : '';
  var studentInternationalHome = student.internationalHome ? "".concat(student.countryOfHomeName || '') : "".concat(student.stateOfHome || '');
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    id: "toggler"
  }, /*#__PURE__*/_react.default.createElement(_styled.WrapperTitle, null, /*#__PURE__*/_react.default.createElement(_styled.Title, null, "".concat((0, _capitalize.default)(student.firstName.trim()), " ").concat((0, _first.default)(student.lastName.toUpperCase()), ".")), /*#__PURE__*/_react.default.createElement(_styled.SubTitle, null, subtitle))), /*#__PURE__*/_react.default.createElement(_styled.Container, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-block"
  }, showPhone && /*#__PURE__*/_react.default.createElement("p", {
    className: "text"
  }, "\uD83D\uDCF1 ", " ".concat((0, _utils.getFormatPhone)(student.phone)), " |", ' ', /*#__PURE__*/_react.default.createElement(_styled.HyperlinkEmail, {
    href: "mailto:".concat(student.email)
  }, "\uD83D\uDCE7 ", " ".concat(student.email))), /*#__PURE__*/_react.default.createElement("div", {
    className: "bio__intro"
  }, student.universityName && /*#__PURE__*/_react.default.createElement("h3", {
    className: "title"
  }, student.universityName), /*#__PURE__*/_react.default.createElement("p", {
    className: "text"
  }, title)), /*#__PURE__*/_react.default.createElement("p", {
    className: "text"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "strong"
  }, "Hometown: "), "".concat(studentCityOfHomeName).concat(studentInternationalHome)), student.myselfEmoji && /*#__PURE__*/_react.default.createElement("p", {
    className: "text text-emoji"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "strong"
  }, "Me in 5 Emojis: "), /*#__PURE__*/_react.default.createElement("span", {
    role: "img",
    "aria-label": "Emojis"
  }, student.myselfEmoji)), !(0, _isEmpty.default)(diversities) && viewDiversities && /*#__PURE__*/_react.default.createElement("p", {
    className: "text"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "strong"
  }, "My Diversities: "), diversities.filter(function (diver) {
    return diver.includeOnResume;
  }).map(function (diversity) {
    return "".concat((0, _utils.getDiversityName)(diversity));
  }).join(', '))), /*#__PURE__*/_react.default.createElement(_styled.ButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_styled.ResumeButton, {
    onClick: goToMyResume,
    style: {
      opacity: disabledResume ? 0.5 : 1
    }
  }, "resume pdf"), showContactTagsSelector && onContactTag && /*#__PURE__*/_react.default.createElement(_contactTags.default, {
    onShowContactTags: function onShowContactTags(show) {
      return onSetShowContactTags(show);
    },
    applicantId: applicant.id,
    isSaving: isSavingContactTags,
    contactTags: contactTags,
    onSelect: onContactTag,
    applicantContactTag: applicant.contactTag,
    show: showContactTags
  }), showPrivate && /*#__PURE__*/_react.default.createElement(_styled.SeekingButtonContainer, null, /*#__PURE__*/_react.default.createElement(_styled.SeekingButton, {
    onClick: function onClick() {
      return onSeeking('seeking', seeking);
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    checked: seeking,
    value: seeking,
    onChange: _noop.default
  }), /*#__PURE__*/_react.default.createElement("span", null, "Seeking"), /*#__PURE__*/_react.default.createElement(_styled.WrapperCheck, null, /*#__PURE__*/_react.default.createElement(_icons.CheckIcon, {
    height: "13",
    width: "13"
  })))))), /*#__PURE__*/_react.default.createElement(_styled.ChevronDownIconContainer, null, /*#__PURE__*/_react.default.createElement("img", {
    src: _chevronDown.default,
    alt: "Down",
    className: "chevron-down",
    id: "chevronDown"
  })));
};
GeneralInfo.propTypes = {
  student: _utils.studentProps.isRequired,
  goToMyResume: _propTypes.default.func.isRequired,
  onSeeking: _propTypes.default.func.isRequired,
  onSetShowContactTags: _propTypes.default.func,
  onContactTag: _propTypes.default.func,
  isSavingContactTags: _propTypes.default.bool.isRequired,
  disabledResume: _propTypes.default.bool.isRequired,
  viewDiversities: _propTypes.default.bool.isRequired,
  showPrivate: _propTypes.default.bool.isRequired,
  showPhone: _propTypes.default.bool.isRequired,
  showContactTags: _propTypes.default.bool.isRequired,
  showContactTagsSelector: _propTypes.default.bool.isRequired,
  contactTags: _utils.contactTagsPropTypes,
  applicant: _utils.applicantPropTypes
};
GeneralInfo.defaultProps = {
  contactTags: [],
  applicant: {},
  onContactTag: undefined,
  onSetShowContactTags: undefined
};
var _default = GeneralInfo;
exports.default = _default;